/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useCallback, useState } from 'react';

import VideoPlayer from 'components/uiLibrary/VideoPlayer';

import useNewTracking from 'components/Globals/Analytics';
import { COMPONENTS, GOOGLE_OLD_TRACKING_SERVICES, SECTIONS } from 'components/Globals/Analytics/constants';
import ProductionListing from 'components/Productions/Common/ProductionListing';

import { PRODUCTION_LISTING_VIEW_TYPES } from 'constants/index';

import { useQuery } from 'utils/react-query';
import { trackVideoClick } from 'utils/tracking';

import queries from 'containers/Media/queries';

import classes from './DigitalVideoListing.module.scss';

const VIDEO_ACTION_BUTTONS = {
  POSTER: 'poster',
  TRAILER: 'trailer',
  WATCH_OPTIONS: 'watch_options',
  WATCH_ON_CUETV: 'watch_on_cuetv',
  LIVE_NOW: 'live_now',
  STREAM_OPTIONS: 'stream_options',
};

const DigitalVideoListing = ({ queryFn, limit, mediaSlugInCarousel = false }) => {
  const [openTrailerModal, setOpenTrailerModal] = useState(false);
  const [trailerMedia, setTrailerMedia] = useState(null);
  const track = useNewTracking();

  const getTrackingData = useCallback(
    (media, url) => ({
      media_id: media?.id,
      production_id: media?.production?.id,
      location: VIDEO_ACTION_BUTTONS.POSTER,
      production_name: media?.production?.name,
      video_url: url,
    }),
    [],
  );

  const onOpenTrailerModal = useCallback(media => {
    setTrailerMedia(media);
    setOpenTrailerModal(true);
  }, []);

  const onCloseTrailerModal = useCallback(() => {
    setTrailerMedia(null);
    setOpenTrailerModal(false);
  }, []);

  const { data: trailer } = useQuery(
    queries.getProductionTrailer({
      id: trailerMedia?.production?.id,
      queryConfig: {
        enabled: !!trailerMedia?.production?.id,
        onSuccess: response => {
          const trackingData = getTrackingData(trailerMedia, response?.url);
          track.click(trackVideoClick(VIDEO_ACTION_BUTTONS.TRAILER, trackingData), GOOGLE_OLD_TRACKING_SERVICES);
        },
      },
    }),
  );

  return (
    <div className={classes.root}>
      <ProductionListing
        customQueryFn={queryFn || queries.getDigitalVideos}
        viewMode={PRODUCTION_LISTING_VIEW_TYPES.MEDIA}
        limit={limit}
        infinite={false}
        onPlayTrailer={onOpenTrailerModal}
        mediaSlugInCarousel={mediaSlugInCarousel}
        hideFilters
        trackingData={{
          section: SECTIONS.LS_VOD_LISTING,
          component: COMPONENTS.PRODUCTION_SLUG,
        }}
      />
      {openTrailerModal && <VideoPlayer media={trailer} isPlaying onClose={onCloseTrailerModal} />}
    </div>
  );
};

export default DigitalVideoListing;
